import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from '@library-shared/base/base.component';
import { spSite_Client_By_DomainX } from '@models/StoredProcs-Extended/spSite_Client_By_DomainX';
import { SiteService } from '@services/site/site.service';

@Component({
  selector: 'app-view-doc',
  templateUrl: './view-doc.component.html',
  styleUrls: ['./view-doc.component.scss'],
  standalone: false,
})
export class ViewDocComponent extends BaseComponent implements OnInit, AfterViewInit {
  @ViewChild('affirmationContainer') container: ElementRef;

  siteInfo: spSite_Client_By_DomainX;
  viewText = '';
  title = '';
  viewWhat: string;

  constructor(
    private siteService: SiteService,
    private activatedRoute: ActivatedRoute,
  ) {
    super();
  }

  ngOnInit(): void {
    this.activatedRoute.queryParamMap.subscribe((params) => {
      this.viewWhat = params.get('view');

      this.loadData();
    });
  }

  ngAfterViewInit() {}

  get boxHeight(): any {
    return { height: `${this.viewportHeight - 240}px` };
  }

  get textHeight(): any {
    return { height: `${this.viewportHeight - 300}px` };
  }

  loadData() {
    this.isLoading2.set(true);
    this.siteService.Site_Info().subscribe({
      next: (data) => {
        this.siteInfo = data.record;

        switch (this.viewWhat) {
          case 'tos':
            this.viewText = this.siteInfo.terms_of_service;
            this.title = 'Terms of Service';
            break;
          case 'bus':
            this.viewText = this.siteInfo.contact_information;
            this.title = 'Contact Information';
            break;
          case 'ref':
            this.viewText = this.siteInfo.refund_policy;
            this.title = 'Refund Policy';
            break;
        }

        this.isLoading2.set(false);
      },
    });
  }
}
